export const SUB_ACCION_PARTICIPA = 3;
